import { Fragment } from 'react';
import { Marker as LeafletMarker } from 'react-leaflet';
import L from 'leaflet';
import { modifiers } from '@outdoria/ui';

import s from './styles.module.scss';

type MarkerProps = {
  iconUrl: string;
  isSelected: boolean;
  markerId: string;
  position: L.LatLng;
  onClick: () => void;
};
export const Marker = ({
  iconUrl,
  isSelected,
  markerId,
  position,
  onClick,
}: MarkerProps) => {
  const iconClass = modifiers(s, 'marker__thumbnail', { isSelected });

  const icon = new L.DivIcon({
    className: s.marker__icon,
    html: `
      <div class="${s.marker__wrapper}" key="markericon-${markerId}">
        <img src="${iconUrl}" class="${iconClass}"/>
      </div>`,
  });

  return (
    <Fragment key={markerId}>
      <LeafletMarker
        key={`marker-${markerId}`}
        icon={icon}
        position={position}
        eventHandlers={{ click: onClick }}
      />
    </Fragment>
  );
};
